// frontend/src/components/TaskModalHost.jsx
// Project:      Vision ANPR by Castle Traffic Ltd - Automatic Number Plate Recognition
// Author:       Castle Traffic Ltd
// Contact:      dev@castle-traffic.co.uk
// Created:      2026-10-07
// Updated:      2026-10-16 (BST; implementation package)
//
// Description: Global launcher host for the canonical TaskModal.
// Change Log:  2026-10-07 Initial cross-surface task-modal event host.

import React, { useEffect, useState } from "react";
import TaskModal from "./TaskModal";
import TaskListExecutionModal from "./TaskListExecutionModal";

const TaskModalHost = () => {
  const [context, setContext] = useState(null);
  const [listContext, setListContext] = useState(null);

  useEffect(() => {
    const open = (event) => setContext(event?.detail || null);
    window.addEventListener("vision:open-task", open);
    const openList = event => setListContext(event?.detail || null);
    window.addEventListener("vision:open-task-list", openList);
    return () => {
      window.removeEventListener("vision:open-task", open);
      window.removeEventListener("vision:open-task-list", openList);
    };
  }, []);

  return (
    <>
    <TaskListExecutionModal context={listContext} onClose={() => setListContext(null)} />
    <TaskModal
      open={Boolean(context)}
      taskContext={context}
      onClose={() => setContext(null)}
      onChanged={() => window.dispatchEvent(new CustomEvent("vision:tasks-changed"))}
    />
    </>
  );
};

export default TaskModalHost;
